import { render, staticRenderFns } from "./NidValidatedApplicant.vue?vue&type=template&id=64a3b358&lang=html&"
import script from "./NidValidatedApplicant.vue?vue&type=script&lang=js&"
export * from "./NidValidatedApplicant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports